import { Routes, Route } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import './App.css';
import { SnackbarProvider } from 'notistack';
import Navbar from './Components/Navbar/Navbar';
import Home from './Pages/Home/Home';
import Product from './Pages/Product/Product';
import Footer from './Components/Footer/Footer';
import BrandPage from './Pages/BrandPage/BrandPage';
import { AllProducts, NikeProducts, JordansProducts, AdidasProducts, NewBalanceProducts, LVProducts } from './data/products';
import { ScrollToTop } from './Hooks/usePreventScrolling';
import Cart from './Pages/Cart/Cart';
import { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { CartProvider } from './Context/CartContext';
import CartPage from './Pages/Cart/CartPage';
import useScreenWidth from './Hooks/useScreenWidth';
import DataPolicy from './Pages/DataPolicy/DataPolicy';
import TermsOfService from './Pages/TermsOfService/TermsOfService';
import PrivacyPolicy from './Pages/PrivacyPolicy/PrivacyPolicy';
import WhatsappBtn from './Components/WhatsappBtn/WhatsappBtn';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  const [openCart, setopenCart] = useState(false);
  const isWidthLess600 = useScreenWidth() <= 600;

  return (
    <HelmetProvider>
      <CartProvider>
        <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: "top", horizontal: "right" }} autoHideDuration={2500} >
          <div className="App">
            <ScrollToTop />
            <AnimatePresence mode='wait' >
              {openCart && <Cart setopenCart={setopenCart} />}
            </AnimatePresence>

            <Navbar setopenCart={setopenCart} />
            <Routes>
              <Route path='/' element={<Home setopenCart={setopenCart} />} />
              <Route
                path='/all-products'
                element={<BrandPage
                  Products={AllProducts}
                  Recommended={['Nike', 'Jordans', 'Adidas', 'New Balance', 'LV']}
                  title={'All Products'}
                />}
                page={'/all-products'}
              />
              <Route
                path='/nike'
                element={<BrandPage
                  Products={NikeProducts}
                  Recommended={['Jordans', 'Adidas', 'New Balance', 'LV']}
                  title={'All from Nike'}
                />}
                page={'/nike'}
              />
              <Route
                path='/jordans'
                element={<BrandPage
                  Products={JordansProducts}
                  Recommended={['Nike', 'Adidas', 'New Balance', 'LV']}
                  title={'All from Jordans'}
                  page={'/jordans'}
                />}
              />
              <Route
                path='/adidas'
                element={<BrandPage
                  Products={AdidasProducts}
                  Recommended={['Nike', 'Jordans', 'New Balance', 'LV']}
                  title={'All from Adidas'}
                  page={'/adidas'}
                />}
              />
              <Route
                path='/new-balance'
                element={<BrandPage
                  Products={NewBalanceProducts}
                  Recommended={['Nike', 'Jordans', 'Adidas', 'LV']}
                  title={'All from New balance'}
                  page={'/new-balance'}
                />}
              />
              <Route
                path='/lv'
                element={<BrandPage
                  Products={LVProducts}
                  Recommended={['Nike', 'Jordans', 'Adidas', 'New Balance']}
                  title={'All from LV'}
                  page={'/lv'}
                />}
              />
              <Route
                path='/product/:id'
                element={<Product setopenCart={setopenCart} />}
              />

              {isWidthLess600 && <Route path='/cart' element={<CartPage setopenCart={setopenCart} />} />}

              <Route path='/privacy-policy' element={<PrivacyPolicy />} />
              <Route path='/terms-of-service' element={<TermsOfService />} />
              <Route path='/data-security' element={<DataPolicy />} />
              <Route path='*' element={<Home />} />
            </Routes>
            <WhatsappBtn />
            <Footer />
          </div >
          <Analytics />
          <SpeedInsights />
        </SnackbarProvider>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
